import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        version:"v3.1",
        isMobile: document.body.clientWidth < 768 ? true : false,//设备类型
        showBase: false,//图库插件显示/隐藏
        imgUsageType:1,//使用图片的地方
        order:{
            goods_id: "",
          norms_id: "",
          count: "",
          money: "",
        },
        pay_qrcode:{},
        basic:{},
        groupId:"",
        search:"",
        pageSize:"",
        basic:{},
        isMsg:false
    },
    mutations: {
        

    },
    actions: {

    },

})
